<template>
  <div v-if="isEnableHide && active">
    <div :class="{ 'content--hide': isHide }" :style="styleContentHide">
      <div ref="content" :class="!enableFade ? 'text-truncate' : ''">
        <slot />
      </div>
    </div>
    <div :class="{ 'content--fade': isHide }" :style="styleContentFade" />
    <div
      v-if="isHide"
      :class="enableFade ? 'mt-4' : 'mt-2'"
      class="showmore-less btn__show-more"
      @click="isHide = !isHide"
    >
      {{ textShowMore }}
    </div>
    <div
      v-else
      :class="enableFade ? 'mt-4' : ''"
      class="showmore-less btn__show-less"
      @click="isHide = !isHide"
    >
      {{ textShowLess }}
    </div>
  </div>
  <div v-else>
    <div ref="content">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * ref: https://codepen.io/ojbravo/pen/YPJpXe
 */
export default {
  props: {
    /**
     * @type {Number} ส่วนสูงตอนที่ซ่อนเนื้อหา (px)
     */
    height: {
      type: Number,
      default: 150
    },

    active: {
      type: Boolean,
      default: true
    },

    textShowMore: {
      type: String,
      default: 'Show more'
    },

    textShowLess: {
      type: String,
      default: 'Show less'
    },
    enableFade: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    isHide: true,
    contentHeight: 0
  }),

  computed: {
    isEnableHide() {
      return this.contentHeight > this.height;
    },

    styleContentHide() {
      if (this.isHide)
        return {
          'max-height': this.height + 'px'
        };
      else return {};
    },

    styleContentFade() {
      if (this.isHide && this.enableFade)
        return {
          height: this.height + 'px',
          'margin-top': '-' + this.height + 'px'
        };
      else return {};
    }
  },

  mounted() {
    this.contentHeight = this.$refs.content.clientHeight;
  },

  updated() {
    this.contentHeight = this.$refs.content.clientHeight;
  }
};
</script>

<style lang="scss" scoped>
.content--hide {
  overflow: hidden;
}

.content--fade {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 100%));
  position: relative;
}

.showmore-less {
  color: #3c44b1;
  cursor: pointer;
}
</style>
